import { axiosInstance } from "../../../util/axios";
import {
  giftWalletBaseUrlSelector,
  getGiftWalletAuthToken,
  giftCardsBaseUrlSelector
} from "../../../Api/ApiHelper";
import { formatWithPlaceholders } from "../../../util/utils";
export const fetchBalanceByWallet = ({ mobileNumber }) => {
  const baseUrl = giftWalletBaseUrlSelector();
  const url = formatWithPlaceholders(
    `${baseUrl}${process.env.REACT_APP_GET_WALLET_PHONE_API_URL}`,
    mobileNumber
  );
  return axiosInstance.get(url, {
    headers: {
      Authorization: getGiftWalletAuthToken(),
    },
  });
};

export const fetchBalanceByGiftCard = ({ cardNumber }) => {
  const baseUrl = giftCardsBaseUrlSelector();
  const url = formatWithPlaceholders(
    `${baseUrl}${process.env.REACT_APP_GET_WALLET_CARD_NUMBER_API_URL}`,
    cardNumber
  );
  return axiosInstance.get(url, {
    headers: {
      Authorization: getGiftWalletAuthToken(),
    },
  });
};

